import React from 'react';
import { Crown, User, Building2 } from 'lucide-react';
import { Card, SectionTitle } from '../ui';

const pct = (v) => (v == null ? '—' : `${String(v).replace('.', ',')}%`);

export default function ControlChainSection({ chain }) {
  if (!chain?.links?.length) return null;
  const byId = Object.fromEntries(chain.nodes.map((n) => [n.id, n]));
  const owners = (chain.owners || []).filter((o) => o.pct > 25);
  const links = [...chain.links].sort((a, b) => Number(!!byId[a.target]?.root || !!byId[a.source]?.root) < Number(!!byId[b.target]?.root || !!byId[b.source]?.root) ? 1 : -1);
  return (
    <Card className="p-6 mb-6" data-testid="report-control-chain">
      <SectionTitle>Catena di controllo</SectionTitle>
      <p className="text-xs text-[#8A8F97] -mt-2 mb-5">Partecipazioni superiori al 25% lungo la catena societaria, fino al titolare effettivo.</p>
      {owners.length > 0 && (
        <div className="mb-6 space-y-2" data-testid="control-chain-owners">
          {owners.map((o) => (
            <div key={o.code || o.name} className="flex items-start gap-3 p-4 border border-[#D4AF37]/40 bg-[#D4AF37]/[0.06] rounded-sm">
              <Crown size={18} className="text-[#D4AF37] mt-0.5 shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-sm"><span className="font-medium">{o.name}</span> <span className="text-[#D4AF37]">· titolare effettivo {pct(o.pct)}</span></p>
                <p className="text-xs text-[#8A8F97] font-mono">{o.code}</p>
                {o.paths.map((p) => <p key={p} className="text-xs text-[#8A8F97] mt-1">{p}</p>)}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="divide-y divide-[#1F242C]" data-testid="control-chain-links">
        {links.map((l) => {
          const s = byId[l.source] || {};
          const t = byId[l.target] || {};
          const direct = s.root || t.root;
          return (
            <div key={`${l.source}-${l.target}`} className={`flex items-center gap-3 py-2.5 text-sm ${direct ? '' : 'opacity-70'}`}>
              {s.type === 'person' ? <User size={14} className="text-[#D4AF37] shrink-0" /> : <Building2 size={14} className="text-[#8A8F97] shrink-0" />}
              <span className={`flex-1 min-w-0 truncate ${s.root ? 'text-[#D4AF37]' : ''}`}>{s.name}</span>
              <span className="text-xs text-[#5A5F67]">possiede</span>
              <span className="font-mono text-[#D4AF37] w-16 text-right">{pct(l.pct)}</span>
              <span className={`flex-1 min-w-0 truncate ${t.root ? 'text-[#D4AF37]' : ''}`}>{t.name}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
